document.addEventListener('DOMContentLoaded', () => {
  const app = document.getElementById('build-your-own-app');
  if (!app) return;

  const config = window.buildYourOwnConfig || {};

  const pickerEl = document.getElementById('byo-product-picker');
  const panelEl = document.getElementById('byo-builder-panel');
  const previewTitleEl = document.getElementById('byo-preview-title');
  const previewStageEl = document.getElementById('byo-preview-stage');
  const previewSummaryEl = document.getElementById('byo-preview-summary');

  /* =========================
     DATA
     ========================= */

  const COLOR_OPTIONS = [
    { key: 'magenta', label: 'Magenta', hex: '#EC008C' },
    { key: 'orange', label: 'Orange', hex: '#FF6A13' },
    { key: 'bambu_green', label: 'Bambu Green', hex: '#00AE42' },
    { key: 'red', label: 'Red', hex: '#C12E1F' },
    { key: 'cyan', label: 'Cyan', hex: '#0086D6' },
    { key: 'purple', label: 'Purple', hex: '#5E43B7' },
    { key: 'lemon_yellow', label: 'Yellow', hex: '#F7D959' },
    { key: 'gray', label: 'Gray', hex: '#8E9089' }
  ];

  const ZORBLE_COLOR_OPTIONS = [
    { key: 'black', label: 'Black', hex: '#111111' },
    { key: 'white', label: 'White', hex: '#F4F4F1' },
    { key: 'gray', label: 'Gray', hex: '#8E9089' },
    { key: 'yellow', label: 'Yellow', hex: '#F7D959' },
    { key: 'orange', label: 'Orange', hex: '#FF6A13' },
    { key: 'red', label: 'Red', hex: '#C12E1F' },
    { key: 'bright_pink', label: 'Bright Pink', hex: '#FF3F6E' },
    { key: 'magenta', label: 'Magenta', hex: '#EC008C' },
    { key: 'purple', label: 'Purple', hex: '#5E43B7' },
    { key: 'cyan', label: 'Cyan', hex: '#0086D6' },
    { key: 'turquoise', label: 'Turquoise', hex: '#00A7A7' },
    { key: 'green', label: 'Green', hex: '#008B3A' },
    { key: 'bright_green', label: 'Bright Green', hex: '#A7C900' }
  ];

  const LETTER_OPTIONS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const NUMBER_OPTIONS = '0123456789'.split('');
  const TEXTURE_OPTIONS = [
    { key: 'stripes', label: 'Stripes' },
    { key: 'bumps', label: 'Bumps' },
    { key: 'spiral', label: 'Spiral' },
    { key: 'steps', label: 'Steps' }
  ];

  const SHAPES = [
    { key: '1x1', label: '1x1', cells: [[0, 0]] },
    { key: '1x2', label: '1x2', cells: [[0, 0], [0, 1]] },
    { key: '1x3', label: '1x3', cells: [[0, 0], [0, 1], [0, 2]] },
    { key: '1x4', label: '1x4', cells: [[0, 0], [0, 1], [0, 2], [0, 3]] },
    { key: '1x5', label: '1x5', cells: [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4]] },
    { key: '1x6', label: '1x6', cells: [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4], [0, 5]] },
    { key: '1x7', label: '1x7', cells: [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4], [0, 5], [0, 6]] },
    { key: '2x2', label: '2x2', cells: [[0, 0], [0, 1], [1, 0], [1, 1]] },
    { key: '2x3', label: '2x3', cells: [[0, 0], [0, 1], [0, 2], [1, 0], [1, 1], [1, 2]] },
    { key: '2x4', label: '2x4', cells: [[0, 0], [0, 1], [0, 2], [0, 3], [1, 0], [1, 1], [1, 2], [1, 3]] },
    { key: '3x3', label: '3x3', cells: [[0, 0], [0, 1], [0, 2], [1, 0], [1, 1], [1, 2], [2, 0], [2, 1], [2, 2]] },
    { key: 't_shape', label: 'T Shape', cells: [[0, 0], [0, 1], [0, 2], [1, 1]] },
    { key: 'z_shape', label: 'Z Shape', cells: [[0, 0], [0, 1], [1, 1], [1, 2]] },
    { key: 'l_shape', label: 'L Shape', cells: [[0, 0], [1, 0], [2, 0], [2, 1]] },
    { key: 'plus_shape', label: 'Plus Shape', cells: [[0, 1], [1, 0], [1, 1], [1, 2], [2, 1]] }
  ];

  const ZORBLE_IMAGE_MAP = config.zorbleImages || {};

  const PRODUCTS = [
    {
      key: 'shape-clicker',
      label: 'Shape Clicker',
      description: 'Choose a shape, assign square colors, and decide which squares are clicky or quiet.',
      steps: ['Shape', 'Colors', 'Add Design', 'Click Style', 'Review'],
      basePrice: 12,
      variantId: config.shapeClickerVariantId || '',
      state: {
        shapeKey: '1x2',
        orientation: 'horizontal',
        selectedSquare: 0,
        squareColors: [],
        squareClicks: [],
        squareDesigns: [],
        squareDesignTypes: []
      }
    },
    {
      key: 'zorble',
      label: 'Zorble',
      description: 'Pick a color for each side of your custom fidget ball.',
      steps: ['Side 1', 'Side 2', 'Review'],
      basePrice: 16,
      variantId: config.zorbleVariantId || '',
      state: {
        side1Color: 'magenta',
        side2Color: 'cyan'
      }
    },
    {
      key: 'piano',
      label: 'Piano Button Fidget',
      description: 'Build your piano with custom colors for each section.',
      steps: ['Body', 'Buttons', 'Review'],
      basePrice: 18,
      variantId: config.pianoVariantId || '',
      state: {
        shellColor: 'purple',
        baseColor: 'red',
        knobColor: 'orange',
        button1Color: 'magenta',
        button2Color: 'cyan',
        button3Color: 'lemon_yellow',
        selectedButton: 'button1'
      }
    }
  ];

  let activeProductKey = 'shape-clicker';
  let currentStep = 0;

  /* =========================
     HELPERS
     ========================= */

  function getProduct() {
    return PRODUCTS.find((product) => product.key === activeProductKey);
  }

  function getColorByKey(key) {
    return COLOR_OPTIONS.find((color) => color.key === key) || COLOR_OPTIONS[0];
  }

  function getZorbleColorByKey(key) {
    return ZORBLE_COLOR_OPTIONS.find((color) => color.key === key) || ZORBLE_COLOR_OPTIONS[0];
  }

function getZorbleImage(side, colorKey) {
  return ZORBLE_IMAGE_MAP[side]?.[colorKey] || ZORBLE_IMAGE_MAP.base || '';
}

  function getShapeByKey(key) {
    return SHAPES.find((shape) => shape.key === key) || SHAPES[0];
  }

  function getShapeSquareCount(shapeKey) {
    return getShapeByKey(shapeKey).cells.length;
  }

  function getShapeProductData(shapeKey) {
    return config.shapeMap?.[shapeKey] || null;
  }

  function formatPrice(price) {
    const amount = Number(price || 0);

    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  function calculatePrice(product) {
    switch (product.key) {
      case 'shape-clicker':
        return (product.basePrice + getShapeSquareCount(product.state.shapeKey) * 1.25).toFixed(2);
      case 'zorble':
      case 'piano':
      default:
        return product.basePrice.toFixed(2);
    }
  }

  function renderSteps(product) {
    return `
      <div class="byo-steps" style="--step-count: ${product.steps.length};">
        ${product.steps.map((step, index) => {
          const classes = [
            'byo-step-item',
            index === currentStep ? 'is-active' : '',
            index < currentStep ? 'is-complete' : ''
          ].filter(Boolean).join(' ');

          return `
            <div class="${classes}">
              <button
                class="byo-step-button"
                type="button"
                data-step-index="${index}"
                aria-current="${index === currentStep ? 'step' : 'false'}"
              >
                <div class="byo-step-circle">${index + 1}</div>
                <span class="byo-step-label">${step}</span>
              </button>
            </div>
          `;
        }).join('')}
      </div>
    `;
  }

  function renderProductPicker() {
    pickerEl.innerHTML = PRODUCTS.map((product) => `
      <button
        class="byo-product-card ${product.key === activeProductKey ? 'is-active' : ''}"
        data-product-key="${product.key}"
        type="button"
      >
        <h3>${product.label}</h3>
        <p>${product.description}</p>
      </button>
    `).join('');

    pickerEl.querySelectorAll('[data-product-key]').forEach((btn) => {
      btn.addEventListener('click', () => {
        activeProductKey = btn.dataset.productKey;
        currentStep = 0;
        render();
      });
    });
  }

  /* =========================
     SHAPE CLICKER
     ========================= */

  function ensureShapeState() {
    const product = getProduct();
    if (!product || product.key !== 'shape-clicker') return;

    const count = getShapeSquareCount(product.state.shapeKey);

    const ensureArray = (key, fallback) => {
      if (!Array.isArray(product.state[key]) || product.state[key].length !== count) {
        product.state[key] = Array.from(
          { length: count },
          (_, i) => product.state[key]?.[i] ?? fallback
        );
      }
    };

    ensureArray('squareColors', 'gray');
    ensureArray('squareClicks', '');
    ensureArray('squareDesigns', '');
    ensureArray('squareDesignTypes', '');

    if (product.state.selectedSquare > count - 1) {
      product.state.selectedSquare = 0;
    }
  }

  function renderShapeMini(shape) {
    const rows = Math.max(...shape.cells.map((cell) => cell[0])) + 1;
    const cols = Math.max(...shape.cells.map((cell) => cell[1])) + 1;
    const occupied = new Set(shape.cells.map(([r, c]) => `${r}-${c}`));

    let html = `<div class="byo-shape-mini" style="grid-template-columns: repeat(${cols}, 12px);">`;

    for (let r = 0; r < rows; r += 1) {
      for (let c = 0; c < cols; c += 1) {
        html += occupied.has(`${r}-${c}`)
          ? '<span class="byo-shape-mini-cell"></span>'
          : '<span class="byo-shape-mini-cell" style="visibility:hidden;"></span>';
      }
    }

    html += '</div>';
    return html;
  }

  function renderShapeStep(product) {
    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Choose your shape</h3>
      <p class="byo-step-subtitle">Choose your shape.</p>

      <div class="byo-option-grid shapes">
        ${SHAPES.map((shape) => `
          <button
            class="byo-shape-btn ${product.state.shapeKey === shape.key ? 'is-active' : ''}"
            type="button"
            data-shape-key="${shape.key}"
          >
            ${renderShapeMini(shape)}
            <span class="byo-shape-label">${shape.label}</span>
          </button>
        `).join('')}
      </div>

      <h4 style="margin-top:16px;">Orientation</h4>

      <div class="byo-option-grid choices">
        <button
          class="byo-choice ${product.state.orientation === 'horizontal' ? 'is-active' : ''}"
          type="button"
          data-orientation="horizontal"
        >
          Horizontal
        </button>

        <button
          class="byo-choice ${product.state.orientation === 'vertical' ? 'is-active' : ''}"
          type="button"
          data-orientation="vertical"
        >
          Vertical
        </button>
      </div>

      <div class="byo-action-row">
        <span></span>
        <button class="byo-cart-btn" type="button" id="byo-next-btn">Next</button>
      </div>
    `;
  }

  function renderShapeColorStep(product) {
    ensureShapeState();

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Assign a color to each square</h3>
      <p class="byo-step-subtitle">Pick a square first, then choose its color.</p>

      <p class="byo-step-helper">
        Selected square: ${product.state.selectedSquare + 1}. Click a square in the preview to change it.
      </p>

      <div class="byo-option-grid colors">
        ${COLOR_OPTIONS.map((color) => `
          <button
            class="byo-color-btn ${product.state.squareColors[product.state.selectedSquare] === color.key ? 'is-active' : ''}"
            type="button"
            data-color-key="${color.key}"
          >
            <span class="byo-color-swatch" style="background:${color.hex};"></span>
            <span>${color.label}</span>
          </button>
        `).join('')}
      </div>

      <div class="byo-action-row">
        <button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>
        <button class="byo-cart-btn" type="button" id="byo-next-btn">Next</button>
      </div>
    `;
  }

  function renderShapeDesignStep(product) {
    ensureShapeState();

    const selected = product.state.selectedSquare;
    const selectedDesign = product.state.squareDesigns[selected];

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Add a design to each square</h3>
      <p class="byo-step-subtitle">Pick a square, then choose a letter, number, or texture.</p>

      <p class="byo-step-helper">
        Selected square: ${selected + 1}. Click a square in the preview to change it.
      </p>

      <h4>Letters</h4>
      <div class="byo-option-grid design-grid">
        ${LETTER_OPTIONS.map((letter) => `
          <button
            class="byo-choice ${selectedDesign === letter ? 'is-active' : ''}"
            type="button"
            data-design-value="${letter}"
            data-design-type="letter"
          >
            ${letter}
          </button>
        `).join('')}
      </div>

      <h4 style="margin-top:16px;">Numbers</h4>
      <div class="byo-option-grid design-grid numbers">
        ${NUMBER_OPTIONS.map((number) => `
          <button
            class="byo-choice ${selectedDesign === number ? 'is-active' : ''}"
            type="button"
            data-design-value="${number}"
            data-design-type="number"
          >
            ${number}
          </button>
        `).join('')}
      </div>

      <h4 style="margin-top:16px;">Textures</h4>
      <div class="byo-option-grid choices texture-choice-grid">
        ${TEXTURE_OPTIONS.map((texture) => `
          <button
            class="byo-choice byo-texture-choice ${selectedDesign === texture.key ? 'is-active' : ''}"
            type="button"
            data-design-value="${texture.key}"
            data-design-type="texture"
          >
            <span class="shape-texture-preview texture-${texture.key}"></span>
            <span>${texture.label}</span>
          </button>
        `).join('')}
      </div>

      <div class="byo-action-row">
        <button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>
        <button class="byo-cart-btn" type="button" id="byo-next-btn">Next</button>
      </div>
    `;
  }

  function renderShapeClickStep(product) {
    ensureShapeState();

    const selected = product.state.selectedSquare;

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Choose click style for each square</h3>
      <p class="byo-step-subtitle">Pick a square first, then choose clicky or quiet.</p>

      <p class="byo-step-helper">
        Selected square: ${selected + 1}. Click a square in the preview to change it.
      </p>

      <div class="byo-option-grid choices">
        <button
          class="byo-choice ${product.state.squareClicks[selected] === 'clicky' ? 'is-active' : ''}"
          type="button"
          data-click-type="clicky"
        >
          Clicky
        </button>
        <button
          class="byo-choice ${product.state.squareClicks[selected] === 'quiet' ? 'is-active' : ''}"
          type="button"
          data-click-type="quiet"
        >
          Quiet
        </button>
      </div>

      <div class="byo-action-row">
        <button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>
        <button class="byo-cart-btn" type="button" id="byo-next-btn">Next</button>
      </div>
    `;
  }

  function renderShapeReviewStep(product) {
    const shape = getShapeByKey(product.state.shapeKey);
    const shapeProduct = getShapeProductData(product.state.shapeKey);
    const price = shapeProduct?.price;

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Review your Shape Clicker</h3>
      <p class="byo-step-subtitle">Double-check everything before adding to cart.</p>

      <p class="byo-price">${formatPrice(price)}</p>

      <div class="byo-review-card">
        <p class="byo-review-main">
          Your custom ${shape.label} Shape Clicker is ready.
        </p>

        <p class="byo-review-muted">
          Review your colors, designs, and click styles in the live preview summary before adding it to your cart.
        </p>
      </div>

      <div class="byo-note">
        Your custom selections will be saved with this item at checkout.
      </div>

      <div class="byo-action-row">
        <button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>
        <button class="byo-cart-btn" type="button" id="byo-add-to-cart-btn">Add to cart</button>
      </div>
    `;
  }

  function renderShapePreview(product) {
    ensureShapeState();

    const shape = getShapeByKey(product.state.shapeKey);
    const isVertical = product.state.orientation === 'vertical';

    const rows = Math.max(...shape.cells.map((cell) => cell[0])) + 1;
    const cols = Math.max(...shape.cells.map((cell) => cell[1])) + 1;

    const displayRows = isVertical ? cols : rows;
    const displayCols = isVertical ? rows : cols;
    const map = new Map(shape.cells.map((cell, index) => [`${cell[0]}-${cell[1]}`, index]));

    const maxCellWidth = 92;
    const minCellWidth = 42;
    const availableWidth = 520;
    const availableHeight = 360;

    const cellSizeByWidth = Math.floor((availableWidth - (displayCols - 1) * 12) / displayCols);
    const cellSizeByHeight = Math.floor((availableHeight - (displayRows - 1) * 12) / displayRows);
    const cellSize = Math.max(minCellWidth, Math.min(maxCellWidth, cellSizeByWidth, cellSizeByHeight));
    const gapSize = cellSize >= 70 ? 12 : cellSize >= 56 ? 10 : 8;
    const radius = Math.max(12, Math.floor(cellSize * 0.28));
    const fontSize = Math.max(11, Math.floor(cellSize * 0.52));

    let html = `<div class="shape-preview-grid" style="grid-template-columns: repeat(${displayCols}, ${cellSize}px); gap:${gapSize}px;">`;

    for (let r = 0; r < displayRows; r += 1) {
      for (let c = 0; c < displayCols; c += 1) {
        const sourceRow = isVertical ? c : r;
        const sourceCol = isVertical ? r : c;
        const key = `${sourceRow}-${sourceCol}`;

        if (map.has(key)) {
          const index = map.get(key);
          const color = getColorByKey(product.state.squareColors[index]);
          const clickType = product.state.squareClicks[index] || '';
          const design = product.state.squareDesigns[index] || '';
          const designType = product.state.squareDesignTypes[index] || '';
          const label = design;

          html += `
            <button
              class="shape-preview-cell ${product.state.selectedSquare === index ? 'is-selected' : ''}"
              type="button"
              data-preview-square-index="${index}"
              style="
                width:${cellSize}px;
                height:${cellSize}px;
                border-radius:${radius}px;
                font-size:${fontSize}px;
                background:${color.hex};
              "
            >
              <span class="shape-preview-cell-content">
                ${
                  designType === 'texture'
                    ? `<span class="shape-texture-overlay texture-${design}"></span>`
                    : label
                }
              </span>
              ${clickType ? `
                <span class="shape-preview-click-badge ${clickType === 'clicky' ? 'is-clicky' : 'is-quiet'}">
                  ${clickType === 'clicky' ? 'C' : 'Q'}
                </span>
              ` : ''}
            </button>
          `;
        } else {
          html += `<div style="width:${cellSize}px;height:${cellSize}px;visibility:hidden;"></div>`;
        }
      }
    }

    html += '</div>';

    previewStageEl.innerHTML = html;
    previewSummaryEl.innerHTML = `
      <p><strong>Shape:</strong> ${shape.label}</p>
      <p><strong>Orientation:</strong> ${product.state.orientation}</p>
      <p><strong>Squares:</strong> ${shape.cells.length}</p>
    `;
  }

  /* =========================
     ZORBLE
     ========================= */

  function renderZorbleSideStep(product, sideNumber) {
    const stateKey = sideNumber === 1 ? 'side1Color' : 'side2Color';
    const title = sideNumber === 1 ? 'Choose side 1 color' : 'Choose side 2 color';
    const subtitle = sideNumber === 1
      ? 'This color appears on the left side of the preview.'
      : 'This color appears on the right side of the preview.';

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">${title}</h3>
      <p class="byo-step-subtitle">${subtitle}</p>

      <div class="byo-option-grid colors">
        ${ZORBLE_COLOR_OPTIONS.map((color) => `
          <button
            class="byo-color-btn ${product.state[stateKey] === color.key ? 'is-active' : ''}"
            type="button"
            data-zorble-side="${sideNumber}"
            data-zorble-color="${color.key}"
          >
            <span class="byo-color-swatch" style="background:${color.hex};"></span>
            <span>${color.label}</span>
          </button>
        `).join('')}
      </div>

      <div class="byo-action-row">
        ${sideNumber === 1 ? '<span></span>' : '<button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>'}
        <button class="byo-cart-btn" type="button" id="byo-next-btn">Next</button>
      </div>
    `;
  }

  function renderZorbleReviewStep(product) {
    const price = calculatePrice(product);

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Review your Zorble</h3>
      <p class="byo-step-subtitle">Double-check your colors before adding to cart.</p>

      <p class="byo-price">$${price}</p>

      <ul class="byo-review-list">
        <li><strong>Side 1:</strong> ${getZorbleColorByKey(product.state.side1Color).label}</li>
        <li><strong>Side 2:</strong> ${getZorbleColorByKey(product.state.side2Color).label}</li>
      </ul>

      <div class="byo-action-row">
        <button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>
        <button class="byo-cart-btn" type="button" id="byo-add-to-cart-btn">Add to cart</button>
      </div>
    `;
  }

  function renderZorblePreview(product) {
    const side1 = getZorbleColorByKey(product.state.side1Color);
    const side2 = getZorbleColorByKey(product.state.side2Color);
    const baseSrc = ZORBLE_IMAGE_MAP.base || '';
const side1Src = getZorbleImage('left', product.state.side1Color);
const side2Src = getZorbleImage('right', product.state.side2Color);

    previewStageEl.innerHTML = `
      <div class="zorble-preview-images">
        <img class="zorble-image-layer zorble-base-layer" src="${baseSrc}" alt="Zorble base" width="1092" height="954">
        <img class="zorble-image-layer zorble-side-layer zorble-side-1-layer" src="${side1Src}" alt="Zorble side 1 ${side1.label}" width="1092" height="954">
        <img class="zorble-image-layer zorble-side-layer zorble-side-2-layer" src="${side2Src}" alt="Zorble side 2 ${side2.label}" width="1092" height="954">
      </div>
    `;

    previewSummaryEl.innerHTML = `
      <p><strong>Side 1:</strong> ${side1.label}</p>
      <p><strong>Side 2:</strong> ${side2.label}</p>
    `;
  }

  /* =========================
     PIANO
     ========================= */

  function renderPianoBodyStep(product) {
    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Choose your piano body colors</h3>
      <p class="byo-step-subtitle">Pick colors for the shell, base, and knob.</p>

      <h4>Shell</h4>
      <div class="byo-option-grid colors" style="margin-bottom:16px;">
        ${COLOR_OPTIONS.map((color) => `
          <button class="byo-color-btn ${product.state.shellColor === color.key ? 'is-active' : ''}" type="button" data-piano-shell-color="${color.key}">
            <span class="byo-color-swatch" style="background:${color.hex};"></span>
            <span>${color.label}</span>
          </button>
        `).join('')}
      </div>

      <h4>Base</h4>
      <div class="byo-option-grid colors" style="margin-bottom:16px;">
        ${COLOR_OPTIONS.map((color) => `
          <button class="byo-color-btn ${product.state.baseColor === color.key ? 'is-active' : ''}" type="button" data-piano-base-color="${color.key}">
            <span class="byo-color-swatch" style="background:${color.hex};"></span>
            <span>${color.label}</span>
          </button>
        `).join('')}
      </div>

      <h4>Knob</h4>
      <div class="byo-option-grid colors">
        ${COLOR_OPTIONS.map((color) => `
          <button class="byo-color-btn ${product.state.knobColor === color.key ? 'is-active' : ''}" type="button" data-piano-knob-color="${color.key}">
            <span class="byo-color-swatch" style="background:${color.hex};"></span>
            <span>${color.label}</span>
          </button>
        `).join('')}
      </div>

      <div class="byo-action-row">
        <span></span>
        <button class="byo-cart-btn" type="button" id="byo-next-btn">Next</button>
      </div>
    `;
  }

  function renderPianoButtonsStep(product) {
    const buttonOptions = [
      { key: 'button1', label: 'Button 1', colorKey: product.state.button1Color },
      { key: 'button2', label: 'Button 2', colorKey: product.state.button2Color },
      { key: 'button3', label: 'Button 3', colorKey: product.state.button3Color }
    ];

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Assign colors to each piano button</h3>
      <p class="byo-step-subtitle">Select a button first, then choose its color.</p>

      <div class="byo-square-selector">
        ${buttonOptions.map((button) => `
          <button
            class="byo-square-chip ${product.state.selectedButton === button.key ? 'is-active' : ''}"
            type="button"
            data-piano-button-select="${button.key}"
          >
            ${button.label}
            <span
              class="byo-color-swatch"
              style="display:inline-block;margin-left:8px;vertical-align:middle;background:${getColorByKey(button.colorKey).hex};"
            ></span>
          </button>
        `).join('')}
      </div>

      <div class="byo-option-grid colors">
        ${COLOR_OPTIONS.map((color) => `
          <button
            class="byo-color-btn ${product.state[`${product.state.selectedButton}Color`] === color.key ? 'is-active' : ''}"
            type="button"
            data-piano-button-color="${color.key}"
          >
            <span class="byo-color-swatch" style="background:${color.hex};"></span>
            <span>${color.label}</span>
          </button>
        `).join('')}
      </div>

      <div class="byo-action-row">
        <button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>
        <button class="byo-cart-btn" type="button" id="byo-next-btn">Next</button>
      </div>
    `;
  }

  function renderPianoReviewStep(product) {
    const price = calculatePrice(product);

    return `
      ${renderSteps(product)}
      <h3 class="byo-step-title">Review your Piano Button Fidget</h3>
      <p class="byo-step-subtitle">Double-check the colors before adding to cart.</p>

      <p class="byo-price">$${price}</p>

      <ul class="byo-review-list">
        <li><strong>Shell:</strong> ${getColorByKey(product.state.shellColor).label}</li>
        <li><strong>Base:</strong> ${getColorByKey(product.state.baseColor).label}</li>
        <li><strong>Knob:</strong> ${getColorByKey(product.state.knobColor).label}</li>
        <li><strong>Button 1:</strong> ${getColorByKey(product.state.button1Color).label}</li>
        <li><strong>Button 2:</strong> ${getColorByKey(product.state.button2Color).label}</li>
        <li><strong>Button 3:</strong> ${getColorByKey(product.state.button3Color).label}</li>
      </ul>

      <div class="byo-action-row">
        <button class="byo-nav-btn" type="button" id="byo-back-btn">Back</button>
        <button class="byo-cart-btn" type="button" id="byo-add-to-cart-btn">Add to cart</button>
      </div>
    `;
  }

  function renderPianoPreview(product) {
    const imageMap = config.pianoImages || {};
    const shellSrc = imageMap.shell?.[product.state.shellColor] || '';
    const baseSrc = imageMap.base?.[product.state.baseColor] || '';
    const knobSrc = imageMap.knob?.[product.state.knobColor] || '';
    const button1Src = imageMap.button1?.[product.state.button1Color] || '';
    const button2Src = imageMap.button2?.[product.state.button2Color] || '';
    const button3Src = imageMap.button3?.[product.state.button3Color] || '';

    previewStageEl.innerHTML = `
      <div class="piano-preview-images">
        <img class="piano-layer piano-layer-base" src="${baseSrc}" alt="Piano base">
        <img class="piano-layer piano-layer-shell" src="${shellSrc}" alt="Piano shell">
        <img class="piano-layer piano-layer-knob" src="${knobSrc}" alt="Piano knob">
        <img class="piano-layer piano-layer-button1" src="${button1Src}" alt="Piano button 1">
        <img class="piano-layer piano-layer-button2" src="${button2Src}" alt="Piano button 2">
        <img class="piano-layer piano-layer-button3" src="${button3Src}" alt="Piano button 3">
      </div>
    `;

    previewSummaryEl.innerHTML = `
      <p><strong>Shell:</strong> ${getColorByKey(product.state.shellColor).label}</p>
      <p><strong>Base:</strong> ${getColorByKey(product.state.baseColor).label}</p>
      <p><strong>Knob:</strong> ${getColorByKey(product.state.knobColor).label}</p>
      <p><strong>Buttons:</strong> ${getColorByKey(product.state.button1Color).label}, ${getColorByKey(product.state.button2Color).label}, ${getColorByKey(product.state.button3Color).label}</p>
    `;
  }

  /* =========================
     ROUTERS
     ========================= */

  function renderBuilderPanel() {
    const product = getProduct();
    let html = '';

    if (product.key === 'shape-clicker') {
      ensureShapeState();

      const shapeSteps = [
        renderShapeStep,
        renderShapeColorStep,
        renderShapeDesignStep,
        renderShapeClickStep,
        renderShapeReviewStep
      ];

      html = shapeSteps[currentStep]?.(product) || '';
    }

    if (product.key === 'zorble') {
      const zorbleSteps = [
        (currentProduct) => renderZorbleSideStep(currentProduct, 1),
        (currentProduct) => renderZorbleSideStep(currentProduct, 2),
        renderZorbleReviewStep
      ];

      html = zorbleSteps[currentStep]?.(product) || '';
    }

    if (product.key === 'piano') {
      const pianoSteps = [
        renderPianoBodyStep,
        renderPianoButtonsStep,
        renderPianoReviewStep
      ];

      html = pianoSteps[currentStep]?.(product) || '';
    }

    panelEl.innerHTML = html;
  }

  function renderPreview() {
    const product = getProduct();
    previewTitleEl.textContent = product.label;

    if (product.key === 'shape-clicker') {
      renderShapePreview(product);
    }

    if (product.key === 'zorble') {
      renderZorblePreview(product);
    }

    if (product.key === 'piano') {
      renderPianoPreview(product);
    }
  }

  /* =========================
     CART
     ========================= */

  function buildProperties(product) {
    if (product.key === 'shape-clicker') {
      const squareDetails = product.state.squareColors.map((colorKey, index) => {
        const click = product.state.squareClicks[index];
        const color = getColorByKey(colorKey).label;
        const design = product.state.squareDesigns[index];

        return [click, color, design]
          .filter(Boolean)
          .join(' ');
      });

      return {
        'Builder Product': product.label,
        'Shape': getShapeByKey(product.state.shapeKey).label,
        'Orientation': product.state.orientation,

        ...Object.fromEntries(
          squareDetails.map((details, index) => [`Square ${index + 1}`, details])
        )
      };
    }

    if (product.key === 'zorble') {
      return {
        'Builder Product': product.label,
        'Side 1 Color': getZorbleColorByKey(product.state.side1Color).label,
        'Side 2 Color': getZorbleColorByKey(product.state.side2Color).label
      };
    }

    if (product.key === 'piano') {
      return {
        'Builder Product': product.label,
        'Shell Color': getColorByKey(product.state.shellColor).label,
        'Base Color': getColorByKey(product.state.baseColor).label,
        'Knob Color': getColorByKey(product.state.knobColor).label,
        'Button 1 Color': getColorByKey(product.state.button1Color).label,
        'Button 2 Color': getColorByKey(product.state.button2Color).label,
        'Button 3 Color': getColorByKey(product.state.button3Color).label
      };
    }

    return {};
  }

  async function addToCart() {
    const product = getProduct();

    let variantId = product.variantId;

    if (product.key === 'shape-clicker') {
      const shapeProduct = getShapeProductData(product.state.shapeKey);
      variantId = shapeProduct?.variantId;
    }

    if (!variantId) {
      alert('This product is missing a Shopify product selection in the theme editor.');
      return;
    }

    const payload = {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: buildProperties(product)
        }
      ]
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Cart request failed');
      }

      window.location.href = '/cart';
    } catch (error) {
      console.error(error);
      alert('Something went wrong while adding this item to the cart.');
    }
  }

  /* =========================
     EVENTS
     ========================= */

  function bindEvents() {
    const product = getProduct();

    previewStageEl.querySelectorAll('[data-preview-square-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.selectedSquare = Number(btn.dataset.previewSquareIndex);
        render();
      });
    });

    panelEl.querySelectorAll('[data-step-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetStep = Number(btn.dataset.stepIndex);
        const maxStep = product.steps.length - 1;

        if (targetStep >= 0 && targetStep <= maxStep) {
          currentStep = targetStep;
          render();
        }
      });
    });

    panelEl.querySelectorAll('[data-shape-key]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.shapeKey = btn.dataset.shapeKey;
        product.state.selectedSquare = 0;
        ensureShapeState();
        render();
      });
    });

    panelEl.querySelectorAll('[data-orientation]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.orientation = btn.dataset.orientation;
        render();
      });
    });

    panelEl.querySelectorAll('[data-color-key]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.squareColors[product.state.selectedSquare] = btn.dataset.colorKey;
        render();
      });
    });

    panelEl.querySelectorAll('[data-design-value]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.squareDesigns[product.state.selectedSquare] = btn.dataset.designValue;
        product.state.squareDesignTypes[product.state.selectedSquare] = btn.dataset.designType;
        render();
      });
    });

    panelEl.querySelectorAll('[data-click-type]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.squareClicks[product.state.selectedSquare] = btn.dataset.clickType;
        render();
      });
    });

    panelEl.querySelectorAll('[data-zorble-side][data-zorble-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const stateKey = btn.dataset.zorbleSide === '1' ? 'side1Color' : 'side2Color';
        product.state[stateKey] = btn.dataset.zorbleColor;
        render();
      });
    });

    panelEl.querySelectorAll('[data-piano-shell-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.shellColor = btn.dataset.pianoShellColor;
        render();
      });
    });

    panelEl.querySelectorAll('[data-piano-base-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.baseColor = btn.dataset.pianoBaseColor;
        render();
      });
    });

    panelEl.querySelectorAll('[data-piano-knob-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.knobColor = btn.dataset.pianoKnobColor;
        render();
      });
    });

    panelEl.querySelectorAll('[data-piano-button-select]').forEach((btn) => {
      btn.addEventListener('click', () => {
        product.state.selectedButton = btn.dataset.pianoButtonSelect;
        render();
      });
    });

    panelEl.querySelectorAll('[data-piano-button-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const selectedButtonKey = product.state.selectedButton;
        product.state[`${selectedButtonKey}Color`] = btn.dataset.pianoButtonColor;
        render();
      });
    });

    const nextBtn = document.getElementById('byo-next-btn');
    const backBtn = document.getElementById('byo-back-btn');
    const addBtn = document.getElementById('byo-add-to-cart-btn');

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentStep = Math.min(currentStep + 1, product.steps.length - 1);
        render();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        currentStep = Math.max(currentStep - 1, 0);
        render();
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', addToCart);
    }
  }

  /* =========================
     APP RENDER
     ========================= */

  function render() {
    renderProductPicker();
    renderBuilderPanel();
    renderPreview();
    bindEvents();
  }

  ensureShapeState();
  render();
});